import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import PropTypes from 'prop-types'
import { returnToOrigin } from 'utils/navigate'
import { Message } from '@paypalcorp/worldready-react'
import { Button, HourglassIcon, Link } from '@paypalcorp/pp-react'
import IconPage from 'components/common/IconPage'
import { getRetryErrorContentId, getActionName } from 'utils/content'
import COMMON_FPTI_TAGS from '@/constants/fpti-tags/common'
import { recordClientEvent, recordClientClick, recordImpression } from '../../utils/fpti'
import { serverData } from 'utils/server-data'
const { requestBlockedErrorImpressionTags, tryAgainLaterClickTags } = COMMON_FPTI_TAGS

function RequestBlocked(props) {
  const { legalProductName: legalProductNameProp } = props
  const dispatch = useDispatch()
  
  // Derive legalProductName from serverData if not provided or empty
  const country = serverData.locality?.country
  // eslint-disable-next-line i18n-scan/no-country-dependency
  const legalProductName = legalProductNameProp || (country === 'GB' ? 'card' : 'product')

  useEffect(() => {
    const { actionType, flowInstanceId, fptiEntryPoint } = props
    const flowName = getActionName(actionType)
    const { page, eventName, ...rest } = requestBlockedErrorImpressionTags(flowName)
    recordClientEvent(eventName, { page, flowName, ...rest })
    recordImpression(page, {
      flowInstanceId,
      fptiEntryPoint,
      flowName
    })
  }, [props])

  const contentProps = {
    legalProductName,
    /* eslint-disable react/display-name */
    helpLink: (text) => <Link href="/smarthelp">{text}</Link>,
  }

  const handleTryAgainLater = () => {
    recordClientClick(tryAgainLaterClickTags)
    returnToOrigin(dispatch)
  }

  return (
    <IconPage
      data-testid="retry-error-page"
      icon={<HourglassIcon size="xl" color="sysColorPrimaryMain" />}
      headerId={getRetryErrorContentId('header', props.actionType)}
      contentId={getRetryErrorContentId('content', props.actionType)}
      contentProps={contentProps}
      wrapWithModalContent
    >
      <Button data-testid="retry-later-button" onClick={handleTryAgainLater}>
        <Message id="error.button.tryAgainLater" />
      </Button>
    </IconPage>
  )
}

RequestBlocked.propTypes = {
  actionType: PropTypes.string,
  legalProductName: PropTypes.string,
  flowInstanceId: PropTypes.string,
  fptiEntryPoint: PropTypes.string,
}

export default RequestBlocked
